import React from 'react';
import withApollo from 'lib/withApollo';
import { HELP_CATEGORIES, POPULAR_ARTICLES } from 'content/helpContent';
import { allHelpPosts } from 'contentlayer/generated';
import Footer from 'components/General/Footer';
import HelpCategory from 'components/HelpCenter/HelpCategory';
import { compareDesc } from 'date-fns';
import DashboardPage from 'components/Dashboard/DashboardPage';
import { getUser } from 'helpers/token';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

const HelpCategoryPage = ({ category }) => {
  const router = useRouter();

  const [user, setUser] = useState(null);

  useEffect(() => {
    setUser(getUser());
  }, []);

  const { open } = router.query;

  const generatedOgImage = `https://tfog.b-cdn.net/api/post?title=${encodeURIComponent(
    `TravelFeed Help Center: ${category.title}`,
  )}&image=${encodeURIComponent(
    'https://img.travelfeed.io/tvt3st%2F2023-10-12-10-10-618-help-center-question-mark-jpg',
  )}`;

  return (
    <>
      <DashboardPage
        ogImage={generatedOgImage}
        justTitle={`${category.title} - TravelFeed Help Center`}
        description={category.description}
        showForAnyone
        open={open}
        label="help"
        content={
          <>
            <HelpCategory category={category} />
            {user === undefined && <Footer />}
          </>
        }
      />
    </>
  );
};

export async function getStaticPaths() {
  // Get a list of valid post paths.
  const paths = HELP_CATEGORIES.map(category => ({
    params: { slug: category.slug },
  }));

  return { paths, fallback: false };
}

export async function getStaticProps(context) {
  // Find the post for the current page.
  const cats = HELP_CATEGORIES.find(
    category => category.slug === context.params.slug,
  );
  const { title, description, slug } = cats;

  const articles = allHelpPosts
    .filter(post => post.categories.includes(slug))
    // order by POPULAR_ARTICLES
    .reduce((acc, curr) => {
      if (POPULAR_ARTICLES.includes(curr.slug)) {
        acc.unshift(curr);
      } else {
        acc.push(curr);
      }
      return acc;
    }, [])
    .sort((a, b) => compareDesc(new Date(a.updatedAt), new Date(b.updatedAt)))
    .map(article => ({
      title: article.title,
      slug: article.slug,
      shorttitle: article.shorttitle || null,
      subcategory: article.subcategory || null,
      categories: article.categories,
    }));

  const category = { title, description, articles, slug };

  // Return notFound if the post does not exist.
  if (!category) return { notFound: true };

  // Return the post as page props.
  return { props: { category } };
}

export default withApollo(HelpCategoryPage);
